<template>
	<CritereRechercheLiaisonDossier ref="critereRechercheLiaisonDossier" @rechercher="rechercher" @effacerCriteres="effacerCriteres" 
	:isRecherche="false" @fermer="fermer" :criteresRecherche="rechercheHistoriqueLiaison"/>
	<ResultatLiaisonDossier :dossiers="dossiers" :isRechercheDataLoading="isRechercheDataLoading"/>
</template>

<script>
import CritereRechercheLiaisonDossier from '../../components/dossier/Liaison/CritereRechercheLiaisonDossier.vue';
import ResultatLiaisonDossier from '../../components/dossier/Liaison/ResultatLiaisonDossier.vue';
import axios from 'axios';
import { mapGetters } from 'vuex'


export default {
	name: "dossierLiaison",
	components: {
		CritereRechercheLiaisonDossier,
		ResultatLiaisonDossier
	},
	mounted(){

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
		this.$root.$refs.breadcrumbComp.ajout("Liaison Dossier");
		this.isRechercheDataLoading = true;
		if(this.rechercheHistoriqueLiaison) {
			this.rechercher(this.rechercheHistoriqueLiaison)
		}else {
			this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
			.then((res) => {
				this.assignerResultat(res)
				this.isRechercheDataLoading = false;
			});
		}
	},
	data(){
		return {
			isRechercheDataLoading: false,
			dossiers: [],
		}
	},
	computed: {
		...mapGetters({
			jeton: 'cardex/jeton',
      profil: 'cardex/profil',
			rechercheHistoriqueLiaison: 'dossier/rechercheHistoriqueLiaison'
		})
	},
	methods: {	
		rechercher(critereRechercheDossier) {
			this.isRechercheDataLoading = true;
			this.$store.dispatch('dossier/rechercherAction', critereRechercheDossier)
			.then((res) => {
				this.$store.commit('dossier/AJOUT_RECHERCHE_LIAISON_HISTORIQUE', critereRechercheDossier)
				this.assignerResultat(res)
				this.isRechercheDataLoading = false;
			})
		},

		assignerResultat(res){
			this.dossiers = res.data.entites;
			this.$root.$refs.messagesComp.messagesList = res.data.messages
			this.$refs.critereRechercheLiaisonDossier.assignerListe(res.data.entiteDecision);
			
		},

		effacerCriteres() {
			this.isRechercheDataLoading = true;		
			this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
			.then((res) => {
				this.assignerResultat(res)
				this.isRechercheDataLoading = false;
			})
		},
		fermer() {
			this.$root.$refs.breadcrumbComp.rediriger();
		},  				
	}
}
</script>
